export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "919455904627";
export const PHONE_DISPLAY = "+91 94559 04627";
export const CONTACT_EMAIL = "aadisarvtramultiservices@gmail.com";
export const UPI_ID = "9455904627@pthdfc";
